import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ActivityListernerService } from './core/services/activity-listerner.service';
import { LanguageService } from './core/services/language.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit { 

  questionTypes = environment.app_question_types;

  constructor(
    private activityListener: ActivityListernerService, 
    private languageService: LanguageService,     
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ){
    this.matIconRegistry.addSvgIcon(
      this.questionTypes.FILE.code,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.questionTypes.FILE.icon)
    );
    this.matIconRegistry.addSvgIcon(
      this.questionTypes.MULTIPLE_CHOICE.code,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.questionTypes.MULTIPLE_CHOICE.icon)
    );
    this.matIconRegistry.addSvgIcon(
      this.questionTypes.MULTIPLE_CHOICE_MATRIX.code,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.questionTypes.MULTIPLE_CHOICE_MATRIX.icon)
    );
    this.matIconRegistry.addSvgIcon(
      this.questionTypes.OPEN_DATE.code,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.questionTypes.OPEN_DATE.icon)
    );
    this.matIconRegistry.addSvgIcon(
      this.questionTypes.OPEN_NUMBER_FLOAT.code,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.questionTypes.OPEN_NUMBER_FLOAT.icon)
    );
    this.matIconRegistry.addSvgIcon(
      this.questionTypes.OPEN_NUMBER_INTEGER.code,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.questionTypes.OPEN_NUMBER_INTEGER.icon)
    );
    this.matIconRegistry.addSvgIcon(
      this.questionTypes.OPEN_TEXT.code,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.questionTypes.OPEN_TEXT.icon)
    );
    this.matIconRegistry.addSvgIcon(
      this.questionTypes.SINGLE_CHOICE.code,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.questionTypes.SINGLE_CHOICE.icon)
    );
    this.matIconRegistry.addSvgIcon(
      this.questionTypes.SINGLE_CHOICE_MATRIX.code,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.questionTypes.SINGLE_CHOICE_MATRIX.icon)
    );
  }

  ngOnInit(): void {
    this.activityListener.startMonitoring();
    console.log('Setting user locale...');
    this.languageService.setUserLocale();
  }

}
